import { useCallback, useMemo } from 'react';

const score = (a, b) => {
  let s = 0;
  b.topics.forEach((t) => { if (a.topics.includes(t)) s += 3; });
  b.audience.forEach((x) => { if (a.audience.includes(x)) s += 1; });
  if (a.type && a.type === b.type) s += 1;
  return s;
};

// Returns getRelated(item) → up to `limit` items sharing topics/audience/type, best match first.
export const useRelatedFaqs = (items, limit = 3) => {
  const map = useMemo(() => {
    const m = new Map();
    items.forEach((item) => {
      const ranked = items
        .filter((o) => o.id !== item.id)
        .map((o) => ({ o, s: score(item, o) }))
        .filter(({ s }) => s > 0)
        .sort((x, y) => y.s - x.s || Number(y.o.featured) - Number(x.o.featured))
        .slice(0, limit)
        .map(({ o }) => o);
      m.set(item.id, ranked);
    });
    return m;
  }, [items, limit]);
  return useCallback((item) => map.get(item.id) || [], [map]);
};
